export const messages = {
  en: {
    appFunctionSwitch: {
      title: 'Mini Program Feature Switch',
      desc: 'One switch per feature. When a feature is turned off, the corresponding entry in the mini program will show "Feature not available yet, stay tuned". Unconfigured features are treated as open by default.',
      table: {
        groupName: 'Feature',
        groupCode: 'Feature Code',
        openFlag: 'Open',
        remark: 'Remark',
        updateTime: 'Update Time',
        operation: 'Operation'
      },
      open: 'Open',
      closed: 'Closed',
      enableConfirm: 'Turn on this feature? Users will be able to access it right away.',
      disableConfirm: 'Turn off this feature? Users clicking the entry will see "Feature not available yet, stay tuned".',
      confirmTitle: 'Notice',
      updateSuccess: 'Updated successfully',
      updateFailed: 'Update failed',
      empty: 'No feature switch configured for this community'
    }
  },
  zh: {
    appFunctionSwitch: {
      title: '小程序功能开关',
      desc: '一个功能一个开关。关闭某个功能后，小程序对应入口点击将提示「功能暂未开放，敬请期待」。未配置的功能默认按开放处理。',
      table: {
        groupName: '功能名称',
        groupCode: '功能编码',
        openFlag: '是否开放',
        remark: '备注',
        updateTime: '更新时间',
        operation: '操作'
      },
      open: '已开放',
      closed: '已关闭',
      enableConfirm: '确定开放该功能？用户可立即正常使用。',
      disableConfirm: '确定关闭该功能？用户点击对应入口将提示「功能暂未开放，敬请期待」。',
      confirmTitle: '提示',
      updateSuccess: '修改成功',
      updateFailed: '修改失败',
      empty: '当前小区暂无功能开关配置'
    }
  }
}
